<template>
  <div class="register absolute">

    <div class="whiteBg">
      <div class="title">Register Account</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <span class="chooseArea" @click="chooseArea()">
              <slot name="country_tel">+{{area}}</slot>
              <span><svg t="1566640213388" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2787" width="18" height="18"><path d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z" p-id="2788"></path></svg></span>
           </span>
            <input type="text" v-model="account" placeholder="Enter your phone number" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input type="text" v-model="captcha" placeholder="Please fill in verification code" class="codeIput" />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input type="text" v-model="password" placeholder="Fill in your password" />
          </div>
        </div>
      </div>
      <div class="logon" @click="toregister">register</div>
      <div class="tip">
          Have an existing account?
        <span @click="$router.push({ name: 'Login' })" class="font-color-blue"
          >Login</span>
      </div>
      <div class="tips">
          By clicking "register" I agree to B2C mall
          <span @click="$router.push({ path: '/RegisterService' ,query:{id:10}})" class="font-color-blue">Privacy Policy</span>

          <!--<span @click="$router.push({ name: 'RegisterService' ,query:{id:9}})" class="font-color-blue">Privacy Policy</span>-->

      </div>

    </div>
    <!-- <div class="bottom"></div> -->
  </div>
</template>

<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import {  registerVerify,register } from "@api/user";
import { validatorDefaultCatch } from "@utils/dialog";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import cookie from "@utils/store/cookie";

export default {
  name: "Register",
  data(){
    return{
      type:'register',
      account:'',
      captcha:'',
      password:'',
      area:'',
      bomb_btn:false,
    }
  },
  mixins: [sendVerifyCode],
  mounted:function(){
    this.area =  this.localStorage.get("Area")?this.localStorage.get("Area"):this.localStorage.get("default_country_code");
  },
  watch: {
      $route(){
        // this.area = this.$route.params.tel?this.$route.params.tel:this.localStorage.get("default_country_code");
        this.area =  this.localStorage.get("Area")? this.localStorage.get("Area"):this.localStorage.get("default_country_code");
      },
    },
  methods: {
    chooseArea:function(){
      this.$router.push({path:'/selectCode'})
    },
    //注册
  async toregister() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            captcha: [
              required(required.message("verification code")),
              alpha_num(alpha_num.message("verification code"))
            ],
            password: [
              required(required.message("password")),
              attrs.range([6, 16], attrs.range.message("password")),
              alpha_num(alpha_num.message("password"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.area+that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
          setTimeout(() => {
            that.$router.push({path:'/login'})
          }, 500);
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    //发送短信
    async code() {

      var that = this;

      if(!that.account){
        that.$dialog.error("Please enter your phone number");
        return
      }
      let query = {
         phone:that.area+that.account,
         type: that.type
        }
        if(this.bomb_btn){
          return
        }
        this.$dialog.loading.open('loading')
        this.bomb_btn = true
        registerVerify(query)
        .then(res => {
          this.$dialog.loading.close()

          this.bomb_btn = false
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          this.bomb_btn = false
          this.$dialog.loading.close()

          that.$dialog.error(res.msg);
        });
    },
  },

};
</script>

<style scoped>
    .tips{
        height: 1.1rem;
        text-align: center;
        /* line-height: 1.05rem; */
        font-size: 0.3rem;
        color: #cccccc;
    }
</style>
